import type { Channel, Media } from 'lib-shared-types-channels';

import { mediaToChannels } from 'utils/channels';

const dashboardMessagingChannels: Channel[] = [
  ...mediaToChannels.messaging,
  'trustpilotreviews',
  'yotporeviews',
];

/**
 * The dashboard-specific mapping from media to channels.
 *
 * This mapping is slightly different than the presence-specific mapping in `mediaToChannels`, as it
 * moves some channels from `interactivechat` to `messaging` for the purposes of the dashboard.
 */
export const dashboardMediaToChannels: Readonly<
  Record<Media, readonly Channel[]>
> = {
  email: mediaToChannels.email,
  speak: mediaToChannels.speak,
  interactivechat: mediaToChannels.interactivechat.filter(
    (channel) => !dashboardMessagingChannels.includes(channel),
  ),
  messaging: dashboardMessagingChannels,
};
